import React, { createContext, useContext } from 'react';

const ColorModeContext = createContext({
  mode: 'light',
  // eslint-disable-next-line no-unused-vars
  toggleMode: () => {},
});

export function ColorModeProvider({ value, children }) {
  return <ColorModeContext.Provider value={value}>{children}</ColorModeContext.Provider>;
}

export function useColorMode() {
  return useContext(ColorModeContext);
}


